<template>
  <FramePC class="vh-100" style="overflow: auto;" ref="scrollContainer">
    <template v-slot:MainView>
      <HeaderPc />
    </template>

    <template v-slot:MainInfo>
      <MainPanel/>
    </template>

  </FramePC>
</template>

<script>
import FramePC from '@/components/mcf/FramePC.vue';
import HeaderPc from '@/components/HeaderPc.vue';
import MainPanel from '@/components/mcf/MainPanel.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    FramePC,
    HeaderPc,
    MainPanel,
  },
  beforeRouteUpdate(to, from, next) {
    const vm = this;
    // 刷新會員積點資料
    vm.$store.commit('delete', { name: 'memberBonus' });
    vm.$store.dispatch('getMemberBonus');

    // 刷新會員關鍵指標
    vm.$store.commit('delete', { name: 'memberIndicatior' });
    vm.$store.dispatch('getMemberIndicator');
    next();
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        // 有設定頁面 且 進入頁面為首頁
        if (setting.defaultPage && vm.$route.name === 'index') vm.$router.push({ path: `/${setting.defaultPage}`, query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
        document.title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
      });
  },
};
</script>
